export const AlignVerticalCenterIcon = {
  default: {
    a: {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
    },
    path: [
      {
        d: "M5 12L19 12",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
      },
      {
        d: "M7 19L7 5L11 5L11 19H7Z",
        fill: "currentColor",
      },
      {
        d: "M13 15L13 9L17 9L17 15H13Z",
        fill: "currentColor",
      },
    ],
  },
};
